<template>
    <div v-if="!loading">


        <div class="col-12 md:col-12">
            <div class="card card-w-title">
                <HeaderBar :createButton="true" @new-event="addItem = true" title="ویرایش" />


                <div class="grid  mt-5">
                    <div class="col-12 md:col-3">
                        <h6>عنوان</h6>
                        <InputText v-model="slider.title" dir="rtl" />
                    </div>

                    <div class="col-12 md:col-3">
                        <h6>توضیحات</h6>
                        <InputText v-model="slider.subTitle" dir="rtl" />
                    </div>


                    <div class="col-12 md:col-3">
                        <Button @click="postSwapOrderPlace" type="button" class="mt-5" label="ذخیره " />
                    </div>

                </div>



                <div v-if="slider.places.length">
                    <DataTable ref="dt" :value="slider.places" dataKey="id"
                        class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn"
                        responsiveLayout="scroll">
                        <Column field="name" header="عنوان" headerStyle="width:14%; min-width:10rem;">
                            <template #body="slotProps">
                                {{ slotProps.data.name }}
                            </template>
                        </Column>
                        <Column header="عملیات">
                            <template #body="slotProps">
                                <Button icon="pi pi-trash" v-tooltip.top="'حذف'"
                                    class="p-button-rounded p-button-warning mt-2"
                                    @click="confirmDeletePlace(slotProps.data.id)" />
                            </template>
                        </Column>
                        <Column header="جابجایی">
                            <template #body="slotProps">
                                <Button @click="swapOrderPlace(slotProps.data.id)" icon="pi pi-external-link"
                                    class="p-button-rounded p-button-secondary"
                                    :class="{ 'p-button-success': swapOrderPlaceData.FirstPlaceId == slotProps.data.id }, { 'p-button-success': swapOrderPlaceData.SecondPlaceId == slotProps.data.id }" />
                            </template>
                        </Column>

                    </DataTable>
                </div>
                <div v-if="!slider.places.length" class="text-center mt-5">
                    <h5> موردی وجود ندارد</h5>
                </div>

            </div>
        </div>



        <!----------------------------- modal ----------------------------->
        <Dialog v-model:visible="addItem" :style="{ width: '600px' }" header="ایجاد مکان" :modal="true" class="p-fluid">
            <div>
                <div class="col-12 md:col-12">
                    <MultiSelect v-model="placeIds" :options="allWithBriefInfo" filter optionLabel="name"
                        placeholder="انتخاب مکان" optionValue="id" class="w-full">
                        <template #footer>
                            <div class="py-2 px-3">
                                {{ ` موارد انتخاب شده ${placeIds.length} عدد` }}
                            </div>
                        </template>
                    </MultiSelect>
                </div>
            </div>
            <template #footer>
                <Button label="لغو" icon="pi pi-times" class="p-button-text" @click="addItem = false" />
                <Button :disabled="loadingUpdate" type="submit" class="p-button-text" label="ایجاد" icon="pi pi-check"
                    @click="postSwapOrderPlace('placeIds')" />
            </template>
        </Dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            slider: {
                placeIds: [],
                title: null,
                subTitle: null
            },
            loading: true,
            swapOrderPlaceData: {
                FirstPlaceId: null,
                SecondPlaceId: null
            },
            allWithBriefInfo: [],
            placeIds: [],
            addItem: false
        };
    },
    methods: {
        async getHomePageSliderManagment(id) {
            this.loading = true
            await this.axios.get(`HomePageSliderManagment/slider/${id}`).then((data) => {
                this.slider = data.data
                this.loading = false
            })
        },
        async getAllWithBriefInfo() {
            await this.axios.get(`Place/GetAllWithBriefInfo`).then((data) => {
                this.allWithBriefInfo = data.data.data
            })
        },
        swapOrderPlace(id) {
            if (this.swapOrderPlaceData.FirstPlaceId) {
                if (this.swapOrderPlaceData.FirstPlaceId != id) {
                    this.swapOrderPlaceData.SecondPlaceId = id
                    this.slider.places = this.swapObjectsById(this.slider.places, this.swapOrderPlaceData.FirstPlaceId, this.swapOrderPlaceData.SecondPlaceId);
                    this.swapOrderPlaceData.FirstPlaceId = null
                    this.swapOrderPlaceData.SecondPlaceId = null
                    this.postSwapOrderPlace()
                }
                else {
                    this.swapOrderPlaceData.FirstPlaceId = null
                    this.swapOrderPlaceData.SecondPlaceId = null
                }
            }
            else {
                this.swapOrderPlaceData.FirstPlaceId = id
            }
        },
        confirmDeletePlace(id) {
            this.slider.places = this.slider.places.filter(object => object.id !== id);
            this.postSwapOrderPlace()
        },
        async postSwapOrderPlace(status) {
            let placeIdsMain = this.slider.places.map(a => a.id);
            if (status == 'placeIds') {
                placeIdsMain = [...new Set([...placeIdsMain, ...this.placeIds])];
            }
            let data = {
                title: this.slider.title,
                subTitle: this.slider.subTitle,
                placeIds: placeIdsMain
            }
            await this.axios.put(`HomePageSliderManagment/slider/${this.$route.query.id}`, data).then(() => {
                this.showToast(200);
                if (status == 'placeIds') {
                    this.addItem = false
                    this.placeIds = []
                    this.getHomePageSliderManagment(this.$route.query.id);
                }
            })
        },
        swapObjectsById(array, id1, id2) {
            let obj1 = array.find(obj => obj.id === id1);
            let obj2 = array.find(obj => obj.id === id2);
            let temp = obj1;
            obj1 = obj2;
            obj2 = temp;
            let index1 = array.indexOf(obj1);
            let index2 = array.indexOf(obj2);
            array.splice(index1, 1, obj2);
            array.splice(index2, 1, obj1);
            return array;
        }
    },
    mounted() {
        this.getHomePageSliderManagment(this.$route.query.id);
        this.getAllWithBriefInfo()
    },
};
</script>